import script from "./warning-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./warning-list.vue?vue&type=script&lang=ts&setup=true"

import "./warning-list.vue?vue&type=style&index=0&id=d0c4001c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0c4001c"]])

export default __exports__